export const modalEuropaLeagueModule = {
  name: 'Modal Europa League',
};
